import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Input, InputNumber, message, Switch, Table, Upload } from "antd";
import { useModel } from "../../../models";
import StockSelectionModal from "./StockSelectionModal";
import { v4 as uuidV4 } from "uuid";
import { DICT_KEY, getDictNameByCode, ENV } from "../../../utils/constants";
import SaleOrderService from "./SaleOrderService";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async e => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    const onFocus = () => {
        inputRef.current.select()
    }
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <>
                {

                    (() => {
                        if (dataIndex === "saleNum") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    onFocus={onFocus}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "salePrice") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "discount") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                    { pattern: /^(([0-9]\d?)|100)$/g, message: '折扣必须是大于等于0且小于等于100的整数' },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    onFocus={onFocus}
                                    style={{ width: "100%" }}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                />
                            </Form.Item>
                        } else if (dataIndex === "giftsNum") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    onFocus={onFocus}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "discountPrice") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    onFocus={onFocus}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "isProtect") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <Switch
                                    ref={inputRef}
                                    checked={record[dataIndex] === "1"}
                                    onClick={save}
                                    size="small"
                                />
                            </Form.Item>

                        } else if (dataIndex === "detailsDesc") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                ]}
                            >
                                <Input.TextArea
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        }
                    }
                    )()
                }
            </>
        ) : (
                <div
                    className="editable-cell-value-wrap"
                    style={{
                        paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                >
                    {children}
                </div>
            );
    }

    return <td {...restProps}>{childNode}</td>;
};

export default function ({ getForm }) {
    const [{
        documentMaterialList,
        selectedDocument,
        selectedDocumentMaterialRowKeys,
        detailStatistics,
    }, {
        setDocumentMaterialList,
        setDetailStatistics,
        removeDocumentMaterial,
        setSelectedDocumentMaterialRowKeys,
        setAddMaterialModelVisible,
        downloadDetailTpl,
    }
    ] = useModel("saleOrder");
    const { orderStatus = "014001" } = selectedDocument;
    //财务确认
    const editable01 = (
        orderStatus === "014001"
    );
    // //库房确认(无用)
    // const editable02 = (
    //     orderStatus === "014001"
    // );

    useEffect(() => {

        let saleTotalNum = 0,
            freeTotalNum = 0,
            saleTotalAmount = 0.00,
            receivableTotalAmount = 0.00;
        documentMaterialList.forEach(el => {
            const { saleNum = 0, giftsNum = 0, salePrice = 0.00, discountPrice = 0.00, discount = 100, } = el;
            saleTotalNum = saleTotalNum + saleNum;
            freeTotalNum = freeTotalNum + giftsNum;
            saleTotalAmount = saleTotalAmount + parseInt(el.saleNum) * parseFloat(el.salePrice);
            receivableTotalAmount = receivableTotalAmount + (saleNum - giftsNum) * salePrice * discount / 100 - discountPrice;
        });
        setDetailStatistics({
            saleTotalNum,
            freeTotalNum,
            saleTotalAmount: saleTotalAmount.toFixed(2),
            receivableTotalAmount: receivableTotalAmount.toFixed(2),
        });
    }, [documentMaterialList]);

    const handleSave = row => {
        setDocumentMaterialList(
            documentMaterialList.map(el => {
                if (el.key === row.key) {

                    const { isProtect, saleNum, giftsNum, salePrice, discount, discountPrice } = row;
                    return {
                        ...row,
                        isProtect: isProtect === "1" || isProtect === true ? "1" : "0",
                        // aggregateAmount: (isProtect === "1" ? 0 : salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
                        aggregateAmount: (salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
                    };
                } else {
                    return el;
                }
            })
        )

    }

    const TableHeader = () => {
        const onAdd = () => {
            getForm().validateFields().then(data => {
                setAddMaterialModelVisible(true);
            }).catch(ex => {
                message.error("请输入主表单信息!")
            });
        }
        const onDelete = () => {
            removeDocumentMaterial(selectedDocumentMaterialRowKeys);
        }

        const onDownloadTpl = () => {
            downloadDetailTpl({ showMsg: true, data: {} })
        }

        const onUploadSuccess = (retData) => {
            // console.log(retData);
            const mappedList = retData.map(el => ({
                ...el,
                key: uuidV4(),
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                materialBrandName: getDictNameByCode(DICT_KEY.CM_DICT.BRAND, el.materialBrand),
            }));
            setDocumentMaterialList([...documentMaterialList, ...mappedList]);
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div className="detail-list-statistic color-primary">
                    <span className="margin-left-8">
                        销售数量：{detailStatistics ? detailStatistics.saleTotalNum : 0}
                    </span>
                    <span className="margin-left-16">
                        赠品数量：{detailStatistics ? detailStatistics.freeTotalNum : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        折后总计：{detailStatistics ? detailStatistics.receivableTotalAmount : 0}
                    </span>
                </div>
                <div
                    style={{ width: "460px", textAlign: "right" }}
                    hidden={
                        orderStatus === "014002"
                        || orderStatus === "014003"
                    }
                >
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_ADD_M}>
                        <Button
                            type="primary"
                            onClick={onAdd}
                        >
                            新增商品
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_DEL_M}>
                        <Button className="margin-left-8"
                            onClick={onDelete}
                            disabled={!(selectedDocumentMaterialRowKeys.length > 0)}
                        >
                            删除商品
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_IM}>
                        <Upload {...SaleOrderService.getImportDetailCfg({ onUploadSuccess }, getForm() ? getForm().getFieldValue("priceType") : null)}>
                            <Button className="margin-left-8">导入</Button>
                        </Upload>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SO_ED_DLOAD}>
                        <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>
                    </YhAuth>
                </div>
            </div>
        )
    }

    const columns = [
        {
            title: '',
            width: 50,
            render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            align: 'left',
        },
        {
            title: '商品名称',
            width: 180,
            ellipsis: true,
            dataIndex: 'materialName',
        },
        {
            title: '商品类别',
            width: 140,
            ellipsis: true,
            dataIndex: 'category',
        },
        /*{
            title: '图号',
            width: 140,
            dataIndex: 'replaceNum',
        },*/
        /*{
            title: '单位',
            width: 60,
            dataIndex: 'materialUnitName',
        },*/
        {
            title: '销售数量*',
            width: 80,
            dataIndex: 'saleNum',
            editable: editable01,
            render: text => text ? text : 0

        },
        {
            title: '单价*',
            width: 140,
            dataIndex: 'salePrice',
            editable: editable01,
            render: text => text ? text : 0.00
        },
        {
            title: '折扣*',
            width: 80,
            dataIndex: 'discount',
            editable: editable01,
            render: text => (text ? text : 100) + "%",
        },
        {
            title: '赠品数量*',
            width: 80,
            dataIndex: 'giftsNum',
            editable: editable01,
            render: text => text ? text : 0
        },
        {
            title: '单品优惠*',
            width: 140,
            dataIndex: 'discountPrice',
            editable: editable01,
            render: text => text ? text : 0.00
        },

        {
            title: '总计',
            width: 140,
            dataIndex: 'aggregateAmount',
            // render: text => text ? text : 0.00
            render: (text, record) => {
                // (tmp.isProtect === "1" ? 0 : salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2);
                const { isProtect, salePrice, saleNum, giftsNum, discount, discountPrice } = record;
                // return (isProtect === "1" ? 0 : salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
                return (salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice).toFixed(2)
            }
        },
        {
            title: '三包*',
            width: 100,
            dataIndex: 'isProtect',
            render: (text) => text && text === "1" ? "是" : "否",
            editable: editable01,
        },

        {
            title: '仓库',
            width: 160,
            ellipsis: true,
            dataIndex: 'warehouseName',
        },
        {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
        },
        {
            title: '库存',
            width: 100,
            dataIndex: 'inventoryNum',
        },
        {
            title: '备注*',
            width: 200,
            dataIndex: 'detailsDesc',
            editable: true,
            render: text => text ? text : "无"
        },
    ];
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const mapColumns = handleSave => columns.map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave
            }),
        };
    });

    return (
        <>
            <TableHeader />
            <Table
                components={components}
                columns={mapColumns(handleSave)}
                dataSource={documentMaterialList}
                bordered
                pagination={false}
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys) => {
                        setSelectedDocumentMaterialRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentMaterialRowKeys
                }}
                scroll={{ x: 'max-content', y: 420 }}
            />

            <StockSelectionModal />
        </>
    )
}